import { Platform } from "react-native";
import { Swift as UnsupportedSwift } from "./unsupported";
import { Button, ControlGroup, DisclosureGroup, Divider, Form, Glass, GlassEffectContainer, GeometryReader, Group, GroupBox, ViewThatFits, HStack, Host, LabeledContent, LazyHStack, LazyVStack, LazyHGrid, LazyVGrid, Grid, GridRow, Link, List, Overlay, ViewSlot, ScrollView, ScrollViewReader, Section, Slot, Spacer, SwipeActions, VStack, ZStack } from "./Containers.native";
import { ContextMenu as AndroidContextMenu, Menu as AndroidMenu } from "./AndroidMenu";
import { ContextMenu as IOSContextMenu, Menu as IOSMenu } from "./Menu.native";
import { Page, Pager } from "./Pager.native";
import { Popover } from "./Popover.native";
import { NavigationStack, Toolbar, ToolbarItem, ToolbarItemGroup, ToolbarSpacer } from "./NavigationStack.native";
import { NavigationSplitView } from "./NavigationSplitView.native";
import { FullScreenCover, Sheet } from "./Sheet.native";
import { ArrangementView } from "./ArrangementView.native";
import { withAnimation } from "./withAnimation.native";
import { KeyframeAnimator, PhaseAnimator } from "./Animators.native";
import { CubicKeyframe, KeyframeTrack, LinearKeyframe, MoveKeyframe, SpringKeyframe } from "./keyframes";
import * as Controls from "./generated/Controls.native";
import { Map as MapWithControls } from "./mapControls.native";
import { Tab, Tabs, TabSection, TabViewBottomAccessory, TabViewSlot } from "./Tabs.native";
import { Compose } from "./compose";
import * as UI from "./effects";
import { Widgets, LiveActivities, WidgetUI } from "./widgets/index";
export * from "./extras";
import { Storage } from "./storage/index.native";
import { KeepAwake, useKeepAwake } from "./keep-awake/index";
import { Print } from "./print/index";
import { StoreReview } from "./store-review/index";
import { QuickActions } from "./quick-actions/index";
import { useSizeClass, getSizeClass, useHinge, getHinge, onHingeChange, ReservedRegions, useReservedRegions, useReservedRegionsReady, useWindowSegments, useSpanning } from "./adaptive/index.native";
import { Notifications } from "./notifications";
import { useNativeState } from "./nativeState";
import { TextInput } from "./universal/TextInput/index";
import { Haptics } from "./haptics/index.native";
import { LaunchScreen } from "./launchScreen/index.native";
import { LocalAuthentication } from "./local-authentication/index";
import { ProtectedStore } from "./protected-store/index";
import { Location } from "./location/index";
import { FileSystem } from "./file-system/index.native";
import { Audio } from "./audio/index";
import { CameraView } from "./camera/index.native";
import { Share } from "./share/index";
import { Open } from "./open/index.native";
import { PhotoLibrary } from "./photo-library/index";
import { MapServices } from "./map-services/index";
import { AppTracking } from "./app-tracking/index";
import { AppIcon } from "./app-icon/index";
import { ScreenOrientation } from "./screen-orientation/index";
import { ScreenCapture, usePreventScreenCapture } from "./screen-capture/index";
import { Purchases } from "./purchases/index";
import { ImageManipulator } from "./image-manipulator/index.native";
import { Device } from "./device/index";
import { Motion } from "./motion/index.native";
import { BackgroundTasks } from "./background-tasks/index";
import { AppIntents } from "./app-intents/index";
import { DeviceAttestation } from "./device-attestation/index";
import { Contacts } from "./contacts/index";
import { Calendar } from "./calendar/index";
import { AppInfo } from "./app-info/index.native";
import { ImagePicker } from "./image-picker/index.native";
import { DocumentPicker } from "./document-picker/index.native";
import { Database } from "./database/index.native";
import { VNDocumentCameraViewController } from "./vision-kit/index";
import { MFMailComposeViewController, MFMessageComposeViewController } from "./message-ui/index";
import { DataScannerViewController } from "./data-scanner/index";
import { CNContactViewController, CNMutableContact, CNContactStore } from "./contact-ui/index";
var Menu = Platform.OS === "android" ? AndroidMenu : IOSMenu;
var ContextMenu = Platform.OS === "android" ? AndroidContextMenu : IOSContextMenu;
var Swift = Platform.OS === "ios" ? {
  ArrangementView,
  Tabs,
  Tab,
  TabSection,
  TabViewBottomAccessory,
  TabViewSlot,
  Menu,
  ContextMenu,
  Sheet,
  FullScreenCover,
  Popover,
  Host,
  HStack,
  VStack,
  ZStack,
  Form,
  Section,
  Glass,
  GlassEffectContainer,
  GeometryReader,
  LabeledContent,
  Button,
  List,
  ScrollView,
  ScrollViewReader,
  LazyVStack,
  LazyHStack,
  LazyVGrid,
  LazyHGrid,
  Grid,
  GridRow,
  ControlGroup,
  DisclosureGroup,
  Divider,
  Link,
  Group,
  GroupBox,
  ViewThatFits,
  Overlay,
  ViewSlot,
  SwipeActions,
  Pager,
  Page,
  NavigationStack,
  NavigationSplitView,
  Toolbar,
  ToolbarItem,
  ToolbarItemGroup,
  ToolbarSpacer,
  Spacer,
  Slot,
  withAnimation,
  PhaseAnimator,
  KeyframeAnimator,
  KeyframeTrack,
  LinearKeyframe,
  SpringKeyframe,
  CubicKeyframe,
  MoveKeyframe,
  ...Controls,
  // the generated map takes no children; the wrapper validates and names
  // the map-controls slot while the native view composes it.
  Map: MapWithControls
} : UnsupportedSwift;
export {
  AppIcon,
  AppInfo,
  AppIntents,
  AppTracking,
  Audio,
  BackgroundTasks,
  CNContactStore,
  CNContactViewController,
  CNMutableContact,
  Calendar,
  CameraView,
  Compose,
  Contacts,
  ContextMenu,
  DataScannerViewController,
  Database,
  Device,
  DeviceAttestation,
  DocumentPicker,
  FileSystem,
  Haptics,
  ImageManipulator,
  ImagePicker,
  KeepAwake,
  LaunchScreen,
  LiveActivities,
  LocalAuthentication,
  Location,
  MFMailComposeViewController,
  MFMessageComposeViewController,
  MapServices,
  Menu,
  Motion,
  Notifications,
  Open,
  PhotoLibrary,
  Print,
  ProtectedStore,
  Purchases,
  QuickActions,
  ReservedRegions,
  ScreenCapture,
  ScreenOrientation,
  Share,
  Storage,
  StoreReview,
  Swift,
  TextInput,
  UI,
  VNDocumentCameraViewController,
  WidgetUI,
  Widgets,
  getHinge,
  getSizeClass,
  onHingeChange,
  useHinge,
  useKeepAwake,
  useNativeState,
  usePreventScreenCapture,
  useReservedRegions,
  useReservedRegionsReady,
  useSizeClass,
  useSpanning,
  useWindowSegments
};
//# sourceMappingURL=index.native.js.map
